/**
 * Phi Quick Add Card Product - Custom modal element for product cards
 * Replaces quick-add-modal with phi-quick-add-custom-ui content.
 * Uses pre-rendered content only (no fetch).
 */
if (!customElements.get('phi-quick-add-card-product')) {
  customElements.define(
    'phi-quick-add-card-product',
    class PhiQuickAddCardProduct extends HTMLElement {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="PhiQuickAddInfo-"]');

        // Close button handler (inside phi-quick-add or modal toggle)
        this.querySelector('[id^="PhiModalClose-"]')?.addEventListener('click', () => this.hide(false));
        this.querySelector('[data-close-quick-add]')?.addEventListener('click', () => this.hide(false));

        // ESC key handler
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });

        // Click outside to close (on the modal backdrop)
        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide();
        });
      }

      _isMobile() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      _moveToBody() {
        if (!this._isMobile() || this._movedToBody) return;
        this._originalParent = this.parentNode;
        this._originalNextSibling = this.nextSibling;
        document.body.appendChild(this);
        this._movedToBody = true;
      }

      _restoreToCard() {
        if (!this._movedToBody || !this._originalParent) return;
        if (this._originalNextSibling) {
          this._originalParent.insertBefore(this, this._originalNextSibling);
        } else {
          this._originalParent.appendChild(this);
        }
        this._originalParent = null;
        this._originalNextSibling = null;
        this._movedToBody = false;
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);

        if (preventFocus) this.openedBy = null;

        this.removeAttribute('open');
        if (typeof removeTrapFocus === 'function') removeTrapFocus(this.openedBy);
        if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();

        document.body.dispatchEvent(new CustomEvent('modalClosed'));

        const content = this.querySelector('[role="dialog"]');
        if (content && this._movedToBody) {
          const handleTransitionEnd = () => {
            this._restoreToCard();
            content.removeEventListener('transitionend', handleTransitionEnd);
          };
          content.addEventListener('transitionend', handleTransitionEnd);
          setTimeout(() => {
            if (this._movedToBody) this._restoreToCard();
          }, 400);
        } else {
          this._restoreToCard();
        }
      }

      show(opener) {
        document.querySelectorAll('phi-quick-add-card-product[open]').forEach((other) => {
          if (other !== this) other.hide();
        });
        document.querySelectorAll('quick-add-modal[open]').forEach((other) => other.hide());

        this.openedBy = opener;
        this._moveToBody();

        void this.offsetHeight;
        this.setAttribute('open', '');
        if (typeof trapFocus === 'function') trapFocus(this, this.querySelector('[role="dialog"]'));
        if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();

        requestAnimationFrame(() => {
          this.querySelectorAll('swiper-container').forEach((sc) => {
            if (sc.swiper) {
              sc.swiper.update();
            } else {
              sc.addEventListener('swiperready', () => sc.swiper && sc.swiper.update(), { once: true });
            }
          });
        });
      }
    }
  );
}
